export default {
  badge: '徽章',
  open: '打开',
  close: '关闭',
  dismiss: '取消',
  confirmEdit: {
    ok: '确定',
    cancel: '取消',
  },
  dataIterator: {
    noResultsText: '没有符合条件的结果',
    loadingText: '加载中……',
  },
  dataTable: {
    itemsPerPageText: '每页数目：',
    ariaLabel: {
      sortDescending: '：降序排列。',
      sortAscending: '：升序排列。',
      sortNone: '：未排序。',
      activateNone: '点击以移除排序。',
      activateDescending: '点击以降序排列。',
      activateAscending: '点击以升序排列。',
    },
    sortBy: '排序方式',
  },
  dataFooter: {
    itemsPerPageText: '每页数目：',
    itemsPerPageAll: '全部',
    nextPage: '下一页',
    prevPage: '上一页',
    firstPage: '首页',
    lastPage: '尾页',
    pageText: '{0}-{1} 共 {2}',
  },
  dateRangeInput: {
    divider: '至',
  },
  datePicker: {
    itemsSelected: '已选择 {0} 项',
    range: {
      title: '选择日期',
      header: '输入日期',
    },
    title: '选择日期',
    header: '输入日期',
    input: {
      placeholder: '输入日期',
    },
  },
  noDataText: '没有数据',
  carousel: {
    prev: '上一张',
    next: '下一张',
    ariaLabel: {
      delimiter: '幻灯片 {0} / {1}',
    },
  },
  calendar: {
    moreEvents: '还有 {0} 项',
    today: '今天',
  },
  input: {
    clear: '清除 {0}',
    prependAction: '{0} 前置操作',
    appendAction: '{0} 后置操作',
    otp: '请输入第 {0} 位 OTP',
  },
  fileInput: {
    counter: '{0} 个文件',
    counterSize: '{0} 个文件（共 {1}）',
  },
  fileUpload: {
    title: '拖放文件到此处',
    divider: '或',
    browse: '浏览文件',
  },
  timePicker: {
    am: '上午',
    pm: '下午',
    title: '选择时间',
  },
  pagination: {
    ariaLabel: {
      root: '分页导航',
      next: '下一页',
      previous: '上一页',
      page: '转到页面 {0}',
      currentPage: '当前页 {0}',
      first: '第一页',
      last: '最后一页',
    },
  },
  stepper: {
    next: '下一步',
    prev: '上一步',
  },
  rating: {
    ariaLabel: {
      item: '评分 {0} / {1}',
    },
  },
  loading: '加载中...',
  infiniteScroll: {
    loadMore: '加载更多',
    empty: '没有更多内容',
  },
  rules: {
    required: '此字段为必填项',
    email: '请输入有效的电子邮件地址',
    number: '此字段只能包含数字',
    integer: '此字段只能包含整数',
    capital: '此字段只能包含大写字母',
    maxLength: '您最多可以输入{0}个字符',
    minLength: '您必须至少输入{0}个字符',
    strictLength: '输入字段的长度无效',
    exclude: '字符{0}是不允许的',
    notEmpty: '请至少选择一个值',
    pattern: '格式无效',
  },
}
